/**
 * theme.js — Main JS entry point
 *
 * Compiled to: build/theme/theme-script.js
 * Enqueued by: functions.php (handle: THEME_SLUG-script, in footer)
 */

import { initNavigation }     from './modules/navigation';
import { initFooterAccordion } from './modules/footer-accordion';
import { initConductorPasajeroToggle } from './modules/conductor-pasajero-toggle';

/* -------------------------------------------------------------------------- */
/*  Scroll: add/remove 'is-scrolled' on <body>                                */
/* -------------------------------------------------------------------------- */
( function() {
	const body = document.body;
	let ticking = false;

	function checkScroll() {
		body.classList.toggle( 'is-scrolled', window.scrollY > 0 );
		ticking = false;
	}

	window.addEventListener( 'scroll', function() {
		if ( !ticking ) {
			requestAnimationFrame( checkScroll );
			ticking = true;
		}
	}, { passive: true } );

	checkScroll(); // run once on load
} )();

document.addEventListener( 'DOMContentLoaded', () => {
	initNavigation();
	initFooterAccordion();
	initConductorPasajeroToggle();
} );
